import Vue from 'vue'

import { pickBy, uniqBy } from 'lodash'

import UserSettingService from 'Services/UserSettingService'

const recentKey = 'ContextRecent'

const state = Vue.observable({ recentItems: undefined })

export default {
  computed: {
    recentItems: {
      get () {
        return state.recentItems
      },
      set (value) {
        state.recentItems = value
      }
    }
  },

  methods: {
    addRecent ({ business, merchant }) {
      if (business.id !== null) {
        // add new item first in the list, only pick the business and merchant id when it is not null
        const recentItems = [pickBy({ businessId: business.id, merchantId: merchant.id }), ...this.recentItems]

        // filter out duplicates and take the first 20
        return this.updateRecentItems(uniqBy(recentItems, (item) => [item.businessId, item.merchantId].filter(Boolean).join()).slice(0, 20))
      }
    },

    removeRecent ({ businessId, merchantId }) {
      return this.updateRecentItems(merchantId ? this.recentItems.filter(item => item.merchantId !== merchantId) : this.recentItems.filter(item => !(item.businessId === businessId && typeof item.merchantId === 'undefined')))
    },

    /**
     * Get recent items
     *
     * @param {string} key
     */
    getRecentItems () {
      return UserSettingService.getUserSettings(recentKey, []).then(items => {
        this.recentItems = items
      })
    },

    /**
     * Update recent items
     *
     * @param {Array} value
     */
    updateRecentItems (items) {
      return new Promise((resolve, reject) => {
        UserSettingService.saveUserSettings(recentKey, items).then(() => {
          this.getRecentItems(recentKey).then((setting) => resolve(setting))
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
